/**
 * 当前环境是否为开发模式
 */
export const isDevMode = process.env.NODE_ENV === 'development'

/**
 * 当前环境是否为生产模式
 */
export const isProdMode = process.env.NODE_ENV === 'production'
